<template>
  <div class="container box-space-nav min-height">
    <!-- Checkout Steps -->
    <checkout-steps></checkout-steps>
    <!-- // Checkout Steps -->
    <div id="checkout-error">
      <!-- Complete Registration -->
      <complete-registration></complete-registration>
      <!-- // Complete Registration -->
      <!-- Alert Warning -->
      <alert-helper
        v-if="alert.length"
        :alert="alert"
        :close="true"
        type="warning">
      </alert-helper>
      <!-- // Alert Warning -->
    </div>
    <!-- CREDIT CARD Single Dialog -->
    <single-dialog
      :active="active"
      :large="dialogLarge"
      :id="`dialog-register`"
      :key="`checkout-register-single-dialog`"
      @handleDialog="handleDialog"
      class="color-gray-dark">
      <template v-slot:body="{ closeModal, active }">
        <component
          :is="dialogComponent"
          :creditCardByProduct="creditCardByProduct"
          @handleParentAction="closeModal">
          <template v-slot:default="{ handleParentAction }">
            <div class="col-xs-6">
              <button
                @click="handleParentAction"
                type="button"
                class="btn-gray-inverse btn-block btn-extra-large">
                Cancelar
              </button>
            </div>
          </template>
        </component>
      </template>
    </single-dialog>
    <!-- // Single Dialog -->

    <form
      name="checkout"
      @submit.prevent="handleSubmit">
      <!-- Approval Fields -->
      <approval-fields
        :user="user"
        :company="company"
        :reserves="reserves"
        v-bind.sync="form"></approval-fields>
      <!-- // Approval Fields -->

      <div
        v-if="!creditCardByProduct"
        class="row mb-10">
        <div class="col-sm-6">
          <!-- Select Credit Card -->
          <select-creditcard
            :validation="!(submitted && !isValid)"
            :creditcards="creditcards"
            name="creditcard"
            @handleCreditcard="handleCreditcard"></select-creditcard>
          <!-- / Select Credit Card -->
        </div>
        <div class="col-sm-6">
          <a
            @click.prevent="handleDialog('card-register')"
            href="#"
            class="btn btn-link btn-large size-14 weight-normal">+Adicionar Novo Cartão</a>
        </div>
      </div>

      <!-- Checkout List -->
      <checkout-list
        v-for="(order, index) in Object.keys(orders)"
        :key="`checkout-list-${index}`"
        :index-key="index"
        :order="orders[order]"
        :items="reserves[orders[order].slot]"
        :validation="validation[orders[order].slot]"
        :validationInstallments="!(submitted && !validation.installments)"
        :submitted="submitted"
        :creditCardByProduct="creditCardByProduct">
        <template v-slot:content="{ order, items, validation, validationInstallments }">
          <!-- Items -->
          <component
            :is="order.component"
            :order="order"
            :items="items"
            :validation="validation"
            :validationInstallments="validationInstallments"
            :creditcard="form.creditcard"
            :creditcards="creditcards"
            :creditCardByProduct="creditCardByProduct"
            @handleCreditcard="handleCreditcard"
            @handleParentAction="handleDialog"></component>
          <!-- // Items -->
        </template>
      </checkout-list>
      <!-- // Checkout List -->

      <!-- TOTAL AND FINALIZE-->
      <div class="row mb-20">
        <div class="col-sm-6 mt-5">
          <div class="btn-gray-inverse btn-block btn-extra-large clearfix">
            <span class="pull-left color-gray">Total da sua viagem</span> <span class="size-16 pull-right color-gray">{{ total | brlPrice }}</span>
          </div>
        </div>
        <div class="col-sm-6">
          <div
            :class="{ 'col-sm-6' : device !== 'mobile' }"
            class="mt-5 mb-20">
            <button
              :disabled="disabled"
              type="submit"
              class="btn-blue btn-block btn-extra-large">
              Finalizar
            </button>
          </div>
          <div class="col-sm-6 mt-5 padding-off">
            <span class="size-14 weight-normal"><span class="color-magenta">*</span>É obrigatório selecionar o cartão de crédito para finalizar a compra.</span>
          </div>
        </div>
      </div>
      <!-- // TOTAL AND FINALIZE-->
    </form>

    <!-- LOCKSCREEN -->
    <lockscreen :loading="loading" message="Aguarde enquanto a compra é finalizada"></lockscreen>
    <!-- // LOCKSCREEN -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import CheckoutSteps from '@/components/template/CheckoutSteps'
import AlertHelper from '@/components/ui/AlertHelper'
import CompleteRegistration from '@/components/dialogs/CompleteRegistration'
import SingleDialog from '@/components/ui/SingleDialog'
import CardRegister from "@/components/forms/CardRegister.vue"
import ApprovalFields from '@/views/checkout/ApprovalFields'
import SelectCreditcard from '@/components/fields/SelectCreditcard'
import CheckoutList from '@/views/checkout/CheckoutList'
import HotelItem from '@/views/checkout/HotelItem'
import FlightItem from '@/views/checkout/FlightItem'
import CarItem from '@/views/checkout/CarItem'
import lockscreen from '@/components/lockscreen/index'
import scrollToElement from '@/mixins/scrollToElement'
import device from '@/mixins/device'

export default {
  mixins: [ scrollToElement, device ],
  components: {
    CheckoutSteps,
    AlertHelper,
    CompleteRegistration,
    SingleDialog,
    CardRegister,
    ApprovalFields,
    SelectCreditcard,
    CheckoutList,
    HotelItem,
    FlightItem,
    CarItem,
    lockscreen
  },
  data () {
    return {
      active: false,
      dialogComponent: '',
      dialogLarge: true,
      alert: '',
      form: {
        // CREDIT CARD FOR ALL PRODUCTS
        creditcard: null,
        // CREDIT CARD BY PRODUCT
        creditcard_hotel: null,
        creditcard_flight: null,
        creditcard_car: null,
        clearsale: null,
        flight_orders: [],
        //
        reasons_request: [],
        approver: null,
        cost_center: null,
        mandatory_justification: null,
        // not used (?)
        additional_reasons_request: null
      },
      loading: false,
      submitted: false,
      disabled: false
    }
  },
  created () {
    this.getReserves()
      .then(data => {
        if (!(data['99']) > 0) {
          this.$router.push('/')
        } else {
          this.$ga.page({
            page: '/',
            title: 'Checkout',
            location: window.location.href
          })

          this.getCreditcards()
        }
      })
  },
  computed: {
    ...mapState('auth', ['user', 'company']),
    ...mapState('reserve', [
      'flights',
      'hotels',
      'cars',
      'flightOrders', /* TODO - unify */
      'total'
    ]),
    ...mapState('orders', {
      orders: state => state.types
    }),
    ...mapState('creditcard', {
      creditcards: state => state.results,
      creditCardByProduct: state => state.creditCardByProduct
    }),
    reserves() {
      return {
        hotels: this.hotels,
        flights: this.flights,
        cars: this.cars
      }
    },
    ...mapState('creditcard', {
      creditcardAlert: 'alert'
    }),
    ...mapGetters({
      clearSaleSessionID: 'get_clearsale_token'
    }),
    validation () {
      if (this.creditCardByProduct) {
        return {
          hotels: this.hotels.length && !!this.form.creditcard_hotel,
          flights: this.flights.length && !!this.form.creditcard_flight,
          cars: this.cars.length && !!this.form.creditcard_car,
          installments: this.flightOrders.length && !!this.form.creditcard_flight && this.flightOrders.every((flight) => flight.hasOwnProperty('selected_installment'))
        }
      } else {
        return {
          hotels: this.hotels.length && !!this.form.creditcard,
          flights: this.flights.length && !!this.form.creditcard,
          cars: this.cars.length && !!this.form.creditcard,
          installments: this.flightOrders.length && !!this.form.creditcard && this.flightOrders.every((flight) => flight.hasOwnProperty('selected_installment'))
        }
      }
    },
    isValid () {
      const validation = this.validation
      return  Object.keys(validation).filter(key => validation[key] !== 0).every(key => {
        return validation[key]
      })
    }
  },
  watch: {
    creditcardAlert (data) {
      this.alert = data
    }
  },
  methods: {
    ...mapActions('reserve', [
      'getReserves',
      'postReserveFinalize'
    ]),
    ...mapActions('creditcard', [
      'getCreditcards'
    ]),
    handleDialog (component) {
      this.dialogComponent = component
      this.dialogLarge = (component === 'card-register') ? false : true
      this.active = !this.active
    },
    handleCreditcard (target) {
      if (this.creditCardByProduct) {
        this.form[target.name] = target.value
      } else {
        this.form.creditcard = target.value
      }
    },
    async handleSubmit() {
      this.submitted = true

      if (!this.isValid) {
        this.scrollToElement('checkout-error')
        this.disabled = false
        this.alert = 'Você deve selecionar o cartão de crédito ou cadastrar um novo caso não possua'
        return
      }

      this.disabled = true
      this.loading = true

      const form = {
        ...this.form,
        clearsale: this.clearSaleSessionID,
        flight_orders: this.flightOrders
      }

      try {
        const data = await this.postReserveFinalize(form)

        if (data.error) {
          this.scrollToElement('checkout-error')
          this.alert = data.message
          return
        }

        const routes = {
          partialsuccess: '/paymentpartialsuccess',
          success: '/paymentsuccess',
          analise: '/paymentapproval',
          disapproved: '/paymentdisapproved',
          error: '/paymenterror'
        }

        if (data.message in routes) {
          this.$ga.event({
            eventCategory: 'Checkout',
            eventAction: data.message === 'error' ? 'Error' : 'Success',
            eventLabel: 'Checkout converted',
            eventValue: this.flightOrders.total
          })
          this.$router.push(routes[data.message])
        } else if (data.message === 'order_empty') {
            this.scrollToElement('checkout-error')
            this.alert = 'Esse pedido não pode ser finalizado porque não possui itens.'
        }
        else {
          console.warn(`Resposta inesperada no checkout: ${data.message}`)
        }

      } catch (error) {
        this.scrollToElement('checkout-error')
        this.alert = error?.data?.message || 'Erro inesperado. Tente novamente.'
      } finally {
        this.loading = false
        this.disabled = false
      }
    }

  }
};
</script>
